
 //   Shopify 1.0 file


var stores_GeoJSON = JSON.parse(sjson);

let map;
console.log("stores_GeoJSON=", stores_GeoJSON);
let markers = [];

function initMap() {
    map = new google.maps.Map(document.getElementById("map"), {
        zoom: 7,
        center: {lat: 45.473544, lng: -73.695784}
    }), map.data.addGeoJson(stores_GeoJSON);
    // map.data.setStyle({icon: store_icon});
    const e = "AIzaSyDH9igArE4YSmiHAB4EXij0gPNXBeWcz-0";
    const t = new google.maps.InfoWindow({maxWidth: 450});
    map.data.forEach((e => {
        const o = e.getGeometry().get();
        const s = e.getProperty("title");
        const n = e.getProperty("address");
        const a = e.getProperty("hours");
        const l = e.getProperty("website");
        const r = processTitle(s);
        let i;
        const c = processAddress(n.split(","));
        const d = "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png";
        let p = {lat: o.lat(), lng: o.lng()};
      let g = new google.maps.Marker({position: p, map: map,});
                                       // icon: store_icon});
        g.addListener("click", (() => {
            map.setZoom(14), map.setCenter(g.getPosition()), map.panBy(-130, 0);
            const e = `<div class="info-window" style="margin-left:20px; margin-bottom:20px;">\n          <h2>${r}</h2><p class="info"><b>Address:</b>${c}</p>\n          <p class="info"><b>Website:</b><a href="${l}" target="_blank"> ${l}</a></p>\n        </div>\n        `;
            t.setContent(e), t.setPosition(o), t.setOptions({
                pixelOffset: new google.maps.Size(0, -30),
                maxWidth: 500
            }), t.open(map)
        })), markers.push(g)
    })), console.log("markers=", markers), map.data.addListener("click", (e => {
        console.log("event=", e);
        const o = e.feature.getProperty("category");
        const s = e.feature.getProperty("title");
        const n = e.feature.getProperty("address");
        const a = e.feature.getProperty("hours");
        const l = e.feature.getProperty("website");
        const r = e.feature.getGeometry().get();
        const i = processTitle(s);
        let c;
        const d = processAddress(n.split(","));
        console.log("24 position.lat()=", r.lat());
        const p = `<div style="margin-left:20px; margin-bottom:20px;">\n        <h2>${i}</h2><p class="info"><b>Address:</b>${d}</p>\n        <p class="info"><b>Website:</b><a href="${l}" target="_blank"> ${l}</a></p>\n      </div>\n      `;
        t.setContent(p), t.setPosition(r), t.setOptions({
            pixelOffset: new google.maps.Size(0, -30),
            maxWidth: 500
        }), t.open(map)
    }));
    const o = document.createElement("div");
    const s = document.createElement("div");
    const n = document.createElement("div");
    const a = document.createElement("div");
    const l = document.createElement("input");
    const r = {types: ["address"], componentRestrictions: {country: "ca"}};
    o.setAttribute("id", "pac-card"), a.setAttribute("id", "pac-container"), l.setAttribute("id", "pac-input"), l.setAttribute("type", "text"), l.setAttribute("placeholder", "Enter an address"), a.appendChild(l), o.appendChild(a);
    const i = document.createElement("button");
    i.setAttribute("id", "store-location-button"), i.setAttribute("type", "submit"), i.setAttribute("value", "Search"), i.textContent = "Search", o.appendChild(i);
    const c = undefined;
    document.getElementById("origin-address-container").appendChild(o);
    const d = new google.maps.places.Autocomplete(l, r);
    d.setFields(["address_components", "geometry", "name"]);
    const p = new google.maps.Marker({map: map});
    globalOriginMarker = p, console.log("originMarker=", p), p.setVisible(!1);
    let g = map.getCenter();
    d.addListener("place_changed", (async () => {
        p.setVisible(!1), g = map.getCenter();
        const e = d.getPlace();
        if (!e.geometry) return window.alert("No address available for input: '" + e.name + "'"), void 0;
        console.log("Selected place=", e), g = e.geometry.location, map.setCenter(g), map.setZoom(9), console.log("originLocation=", g), console.log("originLocation.lat=", g.lat()), console.log("originLocation.lng=", g.lng()), p.setPosition(g), p.setVisible(!0), console.log("map.data=", map.data), rankedStores = await calculateDistances(map.data, g), console.log("rankedStores=", rankedStores), showStoresList(map.data, rankedStores)
    }))
}

function loadStoreLocation(e = 2) {
    console.log("In loadStoreLocation storeId=", e);
    let t = stores_GeoJSON.features[e].geometry.coordinates;
    const o = {lat: t[1], lng: t[0]};
    map.setCenter(o), map.setZoom(12), google.maps.event.trigger(markers[e], "click");
    const s = undefined;
    document.getElementById("map").focus({preventScroll: !1})
}

const storeid_2_info = {};

async function calculateDistances(e, t) {
    const o = [];
    const s = [];
    const n = [new google.maps.LatLng(t.lat(), t.lng())];
    const a = [{lat: t.lat(), lng: t.lng()}];
    const l = [];
    const r = [];
    let i = [];
    const c = [];
    e.forEach((e => {
        const t = e.getProperty("storeid");
        const n = e.getGeometry().get();
        o.push(t), s.push(n), l.push(new google.maps.LatLng(n.lat(), n.lng())), r.push({
            lat: n.lat(),
            lng: n.lng()
        }), i.push({storeid: t, lat: n.lat(), lng: n.lng()}), storeid_2_info[t] = {
            title: e.getProperty("title"),
            address: e.getProperty("address")
        }
    })), i.sort((function e(t, o) {
        let s = t.lat - a[0].lat;
        let n = t.lng - a[0].lng;
        let l = o.lat - a[0].lat;
        let r = o.lng - a[0].lng;
        let i;
        return Math.pow(s, 2) + Math.pow(n, 2) - Math.pow(l, 2) - Math.pow(r, 2)
    })), console.log("as_crow_flies=", i);
    for (let e = 0; e < 25; e++) c.push(i[e]), console.log("distance=", Math.pow(i[e].lat - a[0].lat, 2) + Math.pow(i[e].lng - a[0].lng, 2));
    console.log("origin=", t, t.lat(), t.lng()), console.log("as_crow_flies_25=", c);
    const d = new google.maps.DistanceMatrixService;
    console.log("service=", d);
    const p = (e, t) => new Promise(((s, n) => {
        console.log("In my_getDistanceMatrix Promise"), console.log("In my_getDistanceMatrix Promise parameters=", t), e.getDistanceMatrix(t, ((e, a) => {
            if (console.log("In service.getDistanceMatrix parameters=", t), console.log("In service.getDistanceMatrix status=", a), console.log("In service.getDistanceMatrix response=", e), a != google.maps.DistanceMatrixStatus.OK) console.log("In status!=Ok ", e), n(e); else {
                const t = [];
                const n = e.rows[0].elements;
                console.log("results = ", n);
                for (let e = 0; e < n.length; e++) {
                    const s = n[e];
                    const a = s.distance.text;
                    const l = s.distance.value;
                    const r = {storeid: o[e], distanceText: a, distanceVal: l};
                    t.push(r)
                }
                s(t)
            }
        }))
    }));
    const g = {origins: a, destinations: c, travelMode: google.maps.TravelMode.DRIVING};
    console.log("parameters=", g);
    let m = await p(d, g);
    return m.sort(((e, t) => e.distanceVal - t.distanceVal)), m.forEach((e => {
        e.storeid = c[e.storeid].storeid
    })), console.log("distancesList=", m), m
}

function toLowerCaseExceptFirstLetter(e) {
    return e.charAt(0) + e.substring(1).toLowerCase()
}

function capitalizeFirstLetter(e) {
    return e.charAt(0).toUpperCase() + e.substring(1)
}

function isProvince(e) {
    const t = undefined;
    let o = !1;
    return -1 !== ["NL", "PE", "NS", "NB", "QC", "ON", "MB", "SK", "AB", "BC", "UT", "NT", "NU"].indexOf(e.trim()) && (o = !0), o
}

function isPostalCode(e) {
    let t = e.replace(/\s+/g, "");
    return 6 === t.length && !!(t[0].match(/[a-z]/i) && t[2].match(/[a-z]/i) && t[4].match(/[a-z]/i) && t[1].match(/[0-9]/i) && t[3].match(/[0-9]/i) && t[5].match(/[0-9]/i))
}

function processAddress(e) {
    let t = processAddressItem(e[0]);
    let o = 1;
    if (e.length > 1) {
        let s = e[1].trim().substring(0, 4);
        if ("UNIT" !== s && "Unit" !== s || (t += ", " + toLowerCaseExceptFirstLetter(e[1].trim()), o = 2), e.length > o) {
            t += "<br>";
            for (let s = o; s < e.length; s++) {
                let o;
                t += processAddressItem(e[s]), s < e.length - 1 && (t += ", ")
            }
        }
    }
    return t
}

function processAddressItem(e) {
    let t = "";
    if (isPostalCode(e)) t = e.replace(/\s+/g, ""); else {
        let o = e.split(" ");
        for (let e = 0; e < o.length; e++) {
            let s = "";
            if (isProvince(o[e])) s = o[e]; else if (isPostalCode(o[e])) s = o[e]; else {
                let t = o[e].split("-");
                let n = "";
                if (t.length > 1) {
                    for (let e = 0; e < t.length; e++) n += toLowerCaseExceptFirstLetter(t[e]), e < t.length - 1 && (n += "-");
                    s = n
                } else s = toLowerCaseExceptFirstLetter(o[e])
            }
            let n = s.split(".");
            if (n.length > 1) {
                s = n[0] + ". ";
                for (let e = 1; e < n.length; e++) "Des" === n[e] || "des" === n[e] ? s += "des" : s += capitalizeFirstLetter(n[e]), e < n.length - 1 && (s += ". ")
            }
            let a = s.split("/");
            if (a.length > 1) {
                s = a[0] + "/";
                for (let e = 1; e < a.length; e++) s += capitalizeFirstLetter(a[e]), e < a.length - 1 && (s += "/")
            }
            if ("D'" === s.substring(0, 2)) {
                let e = s.split("'");
                s = "d'" + capitalizeFirstLetter(e[1])
            }
            "Des" === s && (s = "des"), t += s, e < o.length - 1 && (t += " ")
        }
    }
    return t
}

function processTitle(e) {
    let t = e.split("#");
    let o = t[0].split("(")[0];
    t = o.split(" "), o = "";
    for (let e = 0; e < t.length; e++) {
        let s;
        o += toLowerCaseExceptFirstLetter(t[e]), e < t.length - 1 && (o += " ")
    }
    return o
}

function showStoresList(e, t) {
    if (0 == t.length) return console.log("empty stores"), void 0;
    let o = document.createElement("div");
    if (document.getElementById("panel")) o = document.getElementById("panel"), o.classList.contains("open") && o.classList.remove("open"); else {
        o.setAttribute("id", "panel");
        const e = document.body;
        e.insertBefore(o, e.childNodes[0])
    }
    while (o.lastChild) o.removeChild(o.lastChild);
    t.forEach((t => {
        let s = document.createElement("div");
        s.setAttribute("class", "store-locator-item"), s.setAttribute("onclick", "loadStoreLocation(" + t.storeid + ")");
        const n = document.createElement("p");
        n.classList.add("place");
        const a = e.getFeatureById(t.storeid);
        let l = processTitle(storeid_2_info[t.storeid]["title"]);
        let r;
        let i = processAddress(storeid_2_info[t.storeid]["address"].split(","));
        n.innerHTML = l + "<br>" + i, s.appendChild(n) ;
        const c = document.createElement("p") ;
        c.classList.add("distanceText"), c.textContent = t.distanceText, s.appendChild(c), o.appendChild(s)
    })), o.classList.add("open")
}

//# sourceMappingURL=/s/files/1/0064/4451/5392/t/69/assets/app3.js.map?v=10137998403424298002